import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Tên dịch vụ", -1)
const _hoisted_4 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Giá nhập", -1)
const _hoisted_6 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Giá bán", -1)
const _hoisted_8 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Giảm giá(theo đơn vị %)", -1)
const _hoisted_10 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Giá thực thu", -1)
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_14 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_16 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Tên liệu trình", -1)
const _hoisted_19 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Giá nhập", -1)
const _hoisted_21 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Giá bán", -1)
const _hoisted_23 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Giảm giá(theo đơn vị %)", -1)
const _hoisted_25 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Giá thực thu", -1)
const _hoisted_27 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Số lần thực hiện", -1)
const _hoisted_29 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", null, "Khoảng cách điều trị(ngày)", -1)
const _hoisted_31 = { class: "p-fluid" }
const _hoisted_32 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_33 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_35 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_36 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Tên sản phẩm", -1)
const _hoisted_38 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Giá nhập", -1)
const _hoisted_40 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, "Giá bán", -1)
const _hoisted_42 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "Giảm giá(theo đơn vị %)", -1)
const _hoisted_44 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Giá thực thu", -1)
const _hoisted_46 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", null, "Số lượng", -1)
const _hoisted_48 = { class: "p-fluid" }
const _hoisted_49 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_50 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "p-fluid" }
const _hoisted_55 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_56 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_57 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", null, "Tên dịch vụ", -1)
const _hoisted_59 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", null, "Giá nhập", -1)
const _hoisted_61 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", null, "Giá bán", -1)
const _hoisted_63 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", null, "Giảm giá(%)", -1)
const _hoisted_65 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", null, "Giá thực thu", -1)
const _hoisted_67 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", null, "Tạm ngưng", -1)
const _hoisted_69 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_70 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", null, "Tên liệu trình", -1)
const _hoisted_72 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", null, "Giá nhập", -1)
const _hoisted_74 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", null, "Giá bán", -1)
const _hoisted_76 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", null, "Giảm giá(%)", -1)
const _hoisted_78 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", null, "Giá thực thu", -1)
const _hoisted_80 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", null, "Số lần thực hiện", -1)
const _hoisted_82 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", null, "Khoảng cách điều trị(ngày)", -1)
const _hoisted_84 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", null, "Tạm ngưng", -1)
const _hoisted_86 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_87 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", null, "Tên sản phẩm", -1)
const _hoisted_89 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", null, "Giá nhập", -1)
const _hoisted_91 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", null, "Giá bán", -1)
const _hoisted_93 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", null, "Giảm giá(%)", -1)
const _hoisted_95 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", null, "Giá thực thu", -1)
const _hoisted_97 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", null, "Số lượng", -1)
const _hoisted_99 = { class: "p-field p-col p-col-6 p-md-3 p-lg-2" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", null, "Tạm ngưng", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, {
          header: "DỊCH VỤ",
          style: {"font-weight":"bold"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "Thêm dịch vụ mới" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_InputText, {
                      id: "tenDichVu",
                      type: "text",
                      modelValue: $setup.dichVuCreate.tenDichVu,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dichVuCreate.tenDichVu) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_InputNumber, {
                      id: "giaNhap",
                      type: "text",
                      modelValue: $setup.dichVuCreate.giaNhap,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.dichVuCreate.giaNhap) = $event)),
                      inputId: "integeronly"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_InputNumber, {
                      id: "giaBan",
                      type: "text",
                      modelValue: $setup.dichVuCreate.giaBan,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => (($setup.dichVuCreate.giaBan) = $event)),
                        $setup.inputGiamGiaDV
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_InputNumber, {
                      id: "giamGia",
                      modelValue: $setup.dichVuCreate.giamGia,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => (($setup.dichVuCreate.giamGia) = $event)),
                        $setup.inputGiamGiaDV
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_InputNumber, {
                      id: "giaThucThu",
                      type: "text",
                      modelValue: $setup.dichVuCreate.giaThucThu,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.dichVuCreate.giaThucThu) = $event)),
                      moinputId: "integeronly"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                ($setup.validDichVu)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "btn-spa-add",
                      label: "Thêm",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.createDichVu()))
                    }))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "btn-spa-add",
                      label: "Thêm",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      disabled: "disabled"
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_Panel, { header: "Danh sách dịch vụ" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_DataTable, {
                    value: $setup.listDichVu,
                    showGridlines: true,
                    paginator: true,
                    stripedRows: "",
                    rows: 10,
                    rowsPerPageOptions: [10,25,50],
                    rowHover: true,
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[8] || (_cache[8] = ($event: any) => (($setup.filters) = $event)),
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    globalFilterFields: ['tenDichVu'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} dịch vụ",
                    columnResizeMode: "fit"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá",
                          class: "p-button-outlined",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.clearFilter())),
                          style: {"width":"100px","margin-right":"10px"}
                        }),
                        _createElementVNode("span", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_InputText, {
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo tên dịch vụ"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "Stt",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tenDichVu",
                        header: "Tên dịch vụ",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "giaBan",
                        header: "Giá bán",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "giamGia",
                        header: "Giảm giá(%)",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "giaThucThu",
                        header: "Giá thực thu",
                        style: {"font-weight":"bold","color":"red"},
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaThucThu)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "ngayTao",
                        dataType: "date",
                        header: "Thời gian tạo",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngayTao)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tamNgung",
                        dataType: "date",
                        header: "Trạng thái",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          (!data.tamNgung)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                style: {"max-width":"200px"},
                                severity: "success",
                                label: "Đang hoạt động",
                                iconPos: "left"
                              }))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                style: {"max-width":"200px"},
                                label: "Tạm ngưng",
                                class: "btn-spa-pause",
                                iconPos: "left"
                              }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "",
                        dataType: "date",
                        header: "Tùy chọn",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createVNode(_component_Button, {
                            style: {"max-width":"200px"},
                            label: "Cập nhật",
                            class: "btn-spa-update",
                            severity: "warning",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            onClick: ($event: any) => ($setup.clickUpdateDichVu(data.id))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "LIỆU TRÌNH" }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "Thêm liệu trình mới" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_InputText, {
                      id: "tenLieuTrinh",
                      type: "text",
                      modelValue: $setup.lieuTrinhCreate.tenLieuTrinh,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.lieuTrinhCreate.tenLieuTrinh) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_InputNumber, {
                      id: "giaNhap",
                      type: "text",
                      modelValue: $setup.lieuTrinhCreate.giaNhap,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.lieuTrinhCreate.giaNhap) = $event)),
                      inputId: "integeronly"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_InputNumber, {
                      id: "giaBan",
                      type: "text",
                      modelValue: $setup.lieuTrinhCreate.giaBan,
                      "onUpdate:modelValue": [
                        _cache[11] || (_cache[11] = ($event: any) => (($setup.lieuTrinhCreate.giaBan) = $event)),
                        $setup.inputGiamGiaLieuTrinh
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_InputNumber, {
                      id: "giamGia",
                      modelValue: $setup.lieuTrinhCreate.giamGia,
                      "onUpdate:modelValue": [
                        _cache[12] || (_cache[12] = ($event: any) => (($setup.lieuTrinhCreate.giamGia) = $event)),
                        $setup.inputGiamGiaLieuTrinh
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_InputNumber, {
                      id: "giaThucThu",
                      type: "text",
                      modelValue: $setup.lieuTrinhCreate.giaThucThu,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.lieuTrinhCreate.giaThucThu) = $event)),
                      inputId: "integeronly"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_InputNumber, {
                      id: "soLanThucHien",
                      type: "text",
                      modelValue: $setup.lieuTrinhCreate.soLanThucHien,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.lieuTrinhCreate.soLanThucHien) = $event)),
                      moinputId: "integeronly"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(_component_InputNumber, {
                      id: "khoangCachDieuTri",
                      type: "text",
                      modelValue: $setup.lieuTrinhCreate.khoangCachDieuTri,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.lieuTrinhCreate.khoangCachDieuTri) = $event)),
                      moinputId: "integeronly"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                ($setup.validLieuTrinh)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "btn-spa-add",
                      label: "Thêm",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.createLieuTrinh()))
                    }))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Thêm",
                      class: "btn-spa-add",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      disabled: "disabled"
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_Panel, { header: "Danh sách liệu trình" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_DataTable, {
                    value: $setup.listLieuTrinh,
                    showGridlines: true,
                    paginator: true,
                    stripedRows: "",
                    rows: 10,
                    rowsPerPageOptions: [10,25,50],
                    rowHover: true,
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[19] || (_cache[19] = ($event: any) => (($setup.filters) = $event)),
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    globalFilterFields: ['tenLieuTrinh'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} liệu trình",
                    columnResizeMode: "fit"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá",
                          class: "p-button-outlined",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.clearFilter())),
                          style: {"width":"100px","margin-right":"10px"}
                        }),
                        _createElementVNode("span", _hoisted_33, [
                          _hoisted_34,
                          _createVNode(_component_InputText, {
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo tên liệu trình"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "Stt",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tenLieuTrinh",
                        header: "Tên liệu trình",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "soLanThucHien",
                        header: "Số lần",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "giaBan",
                        header: "Giá bán",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "giamGia",
                        header: "Giảm giá(%)",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "giaThucThu",
                        header: "Giá thực thu",
                        style: {"font-weight":"bold","color":"red"},
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaThucThu)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "ngayTao",
                        dataType: "date",
                        header: "Thời gian tạo",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngayTao)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "khoangCachDieuTri",
                        header: "Khoảng cách lượt điều trị(ngày)",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "tamNgung",
                        dataType: "date",
                        header: "Trạng thái",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          (!data.tamNgung)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                style: {"max-width":"200px"},
                                severity: "success",
                                label: "Đang hoạt động",
                                iconPos: "left"
                              }))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                style: {"max-width":"200px"},
                                class: "btn-spa-pause",
                                label: "Tạm ngưng",
                                severity: "danger",
                                iconPos: "left"
                              }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "",
                        dataType: "date",
                        header: "Tùy chọn",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createVNode(_component_Button, {
                            style: {"max-width":"200px"},
                            class: "btn-spa-update",
                            label: "Cập nhật",
                            severity: "warning",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            onClick: ($event: any) => ($setup.clickUpdateLieuTrinh(data.id))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "SẢN PHẨM" }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "Thêm sản phẩm mới" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_InputText, {
                      id: "tenSanPham",
                      type: "text",
                      modelValue: $setup.sanPhamCreate.tenSanPham,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.sanPhamCreate.tenSanPham) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_InputNumber, {
                      id: "giaNhap",
                      type: "text",
                      modelValue: $setup.sanPhamCreate.giaNhap,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.sanPhamCreate.giaNhap) = $event)),
                      inputId: "integeronly"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_InputNumber, {
                      id: "giaBan",
                      type: "text",
                      modelValue: $setup.sanPhamCreate.giaBan,
                      "onUpdate:modelValue": [
                        _cache[22] || (_cache[22] = ($event: any) => (($setup.sanPhamCreate.giaBan) = $event)),
                        $setup.inputGiamGiaSanPham
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_InputNumber, {
                      id: "giamGia",
                      modelValue: $setup.sanPhamCreate.giamGia,
                      "onUpdate:modelValue": [
                        _cache[23] || (_cache[23] = ($event: any) => (($setup.sanPhamCreate.giamGia) = $event)),
                        $setup.inputGiamGiaSanPham
                      ],
                      inputId: "integeronly"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode(_component_InputNumber, {
                      id: "giaThucThu",
                      type: "text",
                      modelValue: $setup.sanPhamCreate.giaThucThu,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.sanPhamCreate.giaThucThu) = $event)),
                      inputId: "integeronly"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_InputNumber, {
                      id: "giaNhap",
                      type: "text",
                      modelValue: $setup.sanPhamCreate.soLuongNhap,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.sanPhamCreate.soLuongNhap) = $event)),
                      inputId: "integeronly"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                ($setup.validSanPham)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "btn-spa-add",
                      label: "Thêm",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.createSanPham()))
                    }))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Thêm",
                      class: "btn-spa-add",
                      icon: "pi pi-plus-circle",
                      iconPos: "left",
                      disabled: "disabled"
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_Panel, { header: "Danh sách sản phẩm" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_DataTable, {
                    value: $setup.listSanPham,
                    showGridlines: true,
                    paginator: true,
                    stripedRows: "",
                    rows: 10,
                    rowsPerPageOptions: [10,25,50],
                    rowHover: true,
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[29] || (_cache[29] = ($event: any) => (($setup.filters) = $event)),
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    globalFilterFields: ['tenSanPham'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} sản phẩm",
                    columnResizeMode: "fit"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá",
                          class: "p-button-outlined",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.clearFilter())),
                          style: {"width":"100px","margin-right":"10px"}
                        }),
                        _createElementVNode("span", _hoisted_50, [
                          _hoisted_51,
                          _createVNode(_component_InputText, {
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo tên sản phẩm"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "Stt",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tenSanPham",
                        header: "Tên sản phẩm",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "giaBan",
                        header: "Giá bán",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "giamGia",
                        header: "Giảm giá(%)",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "giaThucThu",
                        header: "Giá thực thu",
                        style: {"font-weight":"bold","color":"red"},
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaThucThu)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soLuongNhap",
                        header: "Số lượng nhập",
                        style: {"font-weight":"bold","color":"#315afa"},
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "soLuongTon",
                        header: "Số lượng tồn",
                        style: {"font-weight":"bold","color":"#00889a"},
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "ngayTao",
                        dataType: "date",
                        header: "Thời gian tạo",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngayTao)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "ngayCapNhat",
                        dataType: "date",
                        header: "Thời gian cập nhật",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngayCapNhat)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tamNgung",
                        dataType: "date",
                        header: "Trạng thái",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          (data.soLuongTon == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _createVNode(_component_Button, {
                                  style: {"max-width":"200px"},
                                  severity: "secondary",
                                  label: "Hết sản phẩm",
                                  iconPos: "left"
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                (!data.tamNgung)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      style: {"max-width":"200px"},
                                      severity: "success",
                                      label: "Đang hoạt động",
                                      iconPos: "left"
                                    }))
                                  : (_openBlock(), _createBlock(_component_Button, {
                                      key: 1,
                                      style: {"max-width":"200px"},
                                      class: "btn-spa-pause",
                                      label: "Tạm ngưng",
                                      severity: "danger",
                                      iconPos: "left"
                                    }))
                              ]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "",
                        dataType: "date",
                        header: "Tùy chọn",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createVNode(_component_Button, {
                            style: {"max-width":"200px"},
                            label: "Cập nhật",
                            class: "btn-spa-update",
                            severity: "warning",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            onClick: ($event: any) => ($setup.clickUpdateSanPham(data.id))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        ($setup.hasUpdateData)
          ? (_openBlock(), _createBlock(_component_Dialog, {
              key: 0,
              visible: $setup.validUpdate,
              "onUpdate:visible": [
                _cache[54] || (_cache[54] = ($event: any) => (($setup.validUpdate) = $event)),
                $setup.onDialogClose
              ],
              modal: "",
              blockScroll: "",
              style: { width: '70vw'},
              breakpoints: { '1500px': '50vw', '1150px': '60vw', '800px': '90vw' }
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_Panel, { header: "Cập nhật dịch vụ" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _createVNode(_component_InputText, {
                            id: "tenDichVu",
                            type: "text",
                            modelValue: $setup.dichVuUpdate.tenDichVu,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.dichVuUpdate.tenDichVu) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _createVNode(_component_InputNumber, {
                            id: "giaNhap",
                            type: "text",
                            modelValue: $setup.dichVuUpdate.giaNhap,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.dichVuUpdate.giaNhap) = $event)),
                            inputId: "integeronly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _createVNode(_component_InputNumber, {
                            id: "giaBan",
                            type: "text",
                            modelValue: $setup.dichVuUpdate.giaBan,
                            "onUpdate:modelValue": [
                              _cache[32] || (_cache[32] = ($event: any) => (($setup.dichVuUpdate.giaBan) = $event)),
                              $setup.inputGiamGiaDVUpdate
                            ],
                            inputId: "integeronly"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createVNode(_component_InputNumber, {
                            id: "giamGia",
                            modelValue: $setup.dichVuUpdate.giamGia,
                            "onUpdate:modelValue": [
                              _cache[33] || (_cache[33] = ($event: any) => (($setup.dichVuUpdate.giamGia) = $event)),
                              $setup.inputGiamGiaDVUpdate
                            ],
                            inputId: "integeronly"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createVNode(_component_InputNumber, {
                            id: "giaThucThu",
                            type: "text",
                            modelValue: $setup.dichVuUpdate.giaThucThu,
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.dichVuUpdate.giaThucThu) = $event)),
                            moinputId: "integeronly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createVNode(_component_InputSwitch, {
                            modelValue: $setup.dichVuUpdate.tamNgung,
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.dichVuUpdate.tamNgung) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      ($setup.validDichVuUpdate)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "btn-spa-update",
                            label: "Cập nhật",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            severity: "warning",
                            onClick: _cache[36] || (_cache[36] = ($event: any) => ($setup.updateDichVu()))
                          }))
                        : (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            label: "Cập nhật",
                            class: "btn-spa-update",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            disabled: "disabled"
                          }))
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, $setup.dichVuUpdate.id > 0]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_Panel, { header: "Cập nhật liệu trình" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createVNode(_component_InputText, {
                            id: "tenLieuTrinh",
                            type: "text",
                            modelValue: $setup.lieuTrinhUpdate.tenLieuTrinh,
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.lieuTrinhUpdate.tenLieuTrinh) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _hoisted_73,
                          _createVNode(_component_InputNumber, {
                            id: "giaNhap",
                            type: "text",
                            modelValue: $setup.lieuTrinhUpdate.giaNhap,
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.lieuTrinhUpdate.giaNhap) = $event)),
                            inputId: "integeronly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _hoisted_75,
                          _createVNode(_component_InputNumber, {
                            id: "giaBan",
                            type: "text",
                            modelValue: $setup.lieuTrinhUpdate.giaBan,
                            "onUpdate:modelValue": [
                              _cache[39] || (_cache[39] = ($event: any) => (($setup.lieuTrinhUpdate.giaBan) = $event)),
                              $setup.inputGiamGiaLieuTrinhUpdate
                            ],
                            inputId: "integeronly"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _createVNode(_component_InputNumber, {
                            id: "giamGia",
                            modelValue: $setup.lieuTrinhUpdate.giamGia,
                            "onUpdate:modelValue": [
                              _cache[40] || (_cache[40] = ($event: any) => (($setup.lieuTrinhUpdate.giamGia) = $event)),
                              $setup.inputGiamGiaLieuTrinhUpdate
                            ],
                            inputId: "integeronly"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _hoisted_79,
                          _createVNode(_component_InputNumber, {
                            id: "giaThucThu",
                            type: "text",
                            modelValue: $setup.lieuTrinhUpdate.giaThucThu,
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.lieuTrinhUpdate.giaThucThu) = $event)),
                            inputId: "integeronly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _hoisted_81,
                          _createVNode(_component_InputNumber, {
                            id: "soLanThucHien",
                            type: "text",
                            modelValue: $setup.lieuTrinhUpdate.soLanThucHien,
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.lieuTrinhUpdate.soLanThucHien) = $event)),
                            moinputId: "integeronly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_82, [
                          _hoisted_83,
                          _createVNode(_component_InputNumber, {
                            id: "khoangCachDieuTri",
                            type: "text",
                            modelValue: $setup.lieuTrinhUpdate.khoangCachDieuTri,
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($setup.lieuTrinhUpdate.khoangCachDieuTri) = $event)),
                            moinputId: "integeronly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_84, [
                          _hoisted_85,
                          _createVNode(_component_InputSwitch, {
                            modelValue: $setup.lieuTrinhUpdate.tamNgung,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($setup.lieuTrinhUpdate.tamNgung) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      ($setup.validLieuTrinhUpdate)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            label: "Cập nhật",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            class: "btn-spa-update",
                            onClick: _cache[45] || (_cache[45] = ($event: any) => ($setup.updateLieuTrinh()))
                          }))
                        : (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "btn-spa-update",
                            label: "Cập nhật",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            disabled: "disabled"
                          }))
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, $setup.lieuTrinhUpdate.id > 0]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createVNode(_component_Panel, { header: "Cập nhật sản phẩm" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _hoisted_88,
                          _createVNode(_component_InputText, {
                            id: "tenSanPham",
                            type: "text",
                            modelValue: $setup.sanPhamUpdate.tenSanPham,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.sanPhamUpdate.tenSanPham) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _hoisted_90,
                          _createVNode(_component_InputNumber, {
                            id: "giaNhap",
                            type: "text",
                            modelValue: $setup.sanPhamUpdate.giaNhap,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (($setup.sanPhamUpdate.giaNhap) = $event)),
                            inputId: "integeronly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_91, [
                          _hoisted_92,
                          _createVNode(_component_InputNumber, {
                            id: "giaBan",
                            type: "text",
                            modelValue: $setup.sanPhamUpdate.giaBan,
                            "onUpdate:modelValue": [
                              _cache[48] || (_cache[48] = ($event: any) => (($setup.sanPhamUpdate.giaBan) = $event)),
                              $setup.inputGiamGiaSanPhamUpdate
                            ],
                            inputId: "integeronly"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _hoisted_94,
                          _createVNode(_component_InputNumber, {
                            id: "giamGia",
                            modelValue: $setup.sanPhamUpdate.giamGia,
                            "onUpdate:modelValue": [
                              _cache[49] || (_cache[49] = ($event: any) => (($setup.sanPhamUpdate.giamGia) = $event)),
                              $setup.inputGiamGiaSanPhamUpdate
                            ],
                            inputId: "integeronly"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          _hoisted_96,
                          _createVNode(_component_InputNumber, {
                            id: "giaThucThu",
                            type: "text",
                            modelValue: $setup.sanPhamUpdate.giaThucThu,
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (($setup.sanPhamUpdate.giaThucThu) = $event)),
                            inputId: "integeronly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_97, [
                          _hoisted_98,
                          _createVNode(_component_InputNumber, {
                            id: "giaNhap",
                            type: "text",
                            modelValue: $setup.sanPhamUpdate.soLuongNhap,
                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (($setup.sanPhamUpdate.soLuongNhap) = $event)),
                            inputId: "integeronly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_99, [
                          _hoisted_100,
                          _createVNode(_component_InputSwitch, {
                            modelValue: $setup.sanPhamUpdate.tamNgung,
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (($setup.sanPhamUpdate.tamNgung) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      ($setup.validSanPhamUpdate)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            label: "Cập nhật",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            class: "btn-spa-update",
                            onClick: _cache[53] || (_cache[53] = ($event: any) => ($setup.updateSanPham()))
                          }))
                        : (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            class: "btn-spa-update",
                            label: "Cập nhật",
                            icon: "pi pi-sync",
                            iconPos: "left",
                            disabled: "disabled"
                          }))
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, $setup.sanPhamUpdate.id > 0]
                ])
              ]),
              _: 1
            }, 8, ["visible", "onUpdate:visible"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}